import { createConsumer } from '@rails/actioncable';

let consumer = null;

export function getConsumer() {
  if (!consumer) {
    consumer = createConsumer('/cable');
  }
  return consumer;
}

export function disconnectConsumer() {
  if (consumer) {
    consumer.disconnect();
    consumer = null;
  }
}

export default getConsumer;
